import CustomerSimpleView from './CustomerSimpleView'

export default CustomerSimpleView
